import {
  titleUI,
  currencyUI,
  currencySchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isRelationshipToVeteran } from '../../../../utils/helpers';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-total-assets-title']),
    netWorthEstimation: {
      ...currencyUI({
        max: 999999999,
      }),
      'ui:options': {
        updateSchema: formData => {
          let title = '';
          if (isRelationshipToVeteran(formData) === 'spouse') {
            title = content['financial-info-total-assets-question-spouse'];
          } else if (isRelationshipToVeteran(formData) === 'child') {
            title = content['financial-info-total-assets-question-child'];
          } else if (isRelationshipToVeteran(formData) === 'custodian') {
            title = content['financial-info-total-assets-question-custodian'];
          }
          return {
            title,
          };
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['netWorthEstimation'],
    properties: {
      netWorthEstimation: currencySchema,
    },
  },
};
